export default "__VITE_ASSET__32c3512e__"